// extracted by mini-css-extract-plugin
module.exports = {"container":"alteration-info-modal-module__container___17yGw","closeButton":"alteration-info-modal-module__closeButton___2A06s"};